import {deleteData, getData, postData, putData} from 'helpers/apiHelper'
import { MAIN_PATH, STORAGE_PLANS } from './apiPath'
import { pickBy } from "lodash";

export function getStoragePlansList(payload) {
  let url = `${MAIN_PATH}${STORAGE_PLANS}`;
  let params = pickBy(payload)
  return getData(url, { params });
}

export function viewStoragePlan(planId) {
  let url = `${MAIN_PATH}${STORAGE_PLANS}/${planId}`;
  return getData(url);
}

export function createStoragePlan(payload) {
  let url = `${MAIN_PATH}${STORAGE_PLANS}`;
  return postData(url, payload);
}

export function updateStoragePlan(payload) {
  let { planId, data } = payload;
  let url = `${MAIN_PATH}${STORAGE_PLANS}/${planId}`;
  return putData(url, data);
}

export function deleteStoragePlan(planId) {
  let url = `${MAIN_PATH}${STORAGE_PLANS}/${planId}`;
  return deleteData(url);
}